import {
  SUBMIT_PRODUCT_REVIEW,
  SUBMIT_PRODUCT_REVIEW_SUCCESS,
  SUBMIT_PRODUCT_REVIEW_FAIL,
  FETCH_REVIEW_DETAIL,
  FETCH_REVIEW_DETAIL_SUCCESS,
  FETCH_REVIEW_DETAIL_ERROR,
  FETCH_REVIEW_LIST,
  FETCH_REVIEW_LIST_SUCCESS,
  FETCH_REVIEW_LIST_ERROR,
  MODIFY_REVIEW,
  MODIFY_REVIEW_SUCCESS,
  MODIFY_REVIEW_ERROR,
} from 'store/actionTypes';

export const submitProductReview = (data) => ({
  type: SUBMIT_PRODUCT_REVIEW,
  payload: data,
});

export const submitProductReviewSuccess = (user) => ({
  type: SUBMIT_PRODUCT_REVIEW_SUCCESS,
  payload: user,
});

export const submitProductReviewError = (message) => ({
  type: SUBMIT_PRODUCT_REVIEW_FAIL,
  payload: message,
});

export const fetchReviewDetail = (data) => ({
  type: FETCH_REVIEW_DETAIL,
  payload: data,
});

export const fetchReviewDetailSuccess = (user) => ({
  type: FETCH_REVIEW_DETAIL_SUCCESS,
  payload: user,
});

export const fetchReviewDetailError = (message) => ({
  type: FETCH_REVIEW_DETAIL_ERROR,
  payload: message,
});

export const fetchReviewList = (data) => ({
  type: FETCH_REVIEW_LIST,
  payload: data,
});

export const fetchReviewListSuccess = (data, pageData) => ({
  type: FETCH_REVIEW_LIST_SUCCESS,
  payload: data,
  pageData,
});

export const fetchReviewListError = (message) => ({
  type: FETCH_REVIEW_LIST_ERROR,
  payload: message,
});

export const modifyReview = (data) => ({
  type: MODIFY_REVIEW,
  payload: data,
});

export const modifyReviewSuccess = (user) => ({
  type: MODIFY_REVIEW_SUCCESS,
  payload: user,
});

export const modifyReviewError = (message) => ({
  type: MODIFY_REVIEW_ERROR,
  payload: message,
});
